// extracted by mini-css-extract-plugin
export var boxItems = "_a4-1";
export var boxItemsLg = "_a4-2";
export var button = "_a4-7";
export var buttonHoverless = "_a4-9";
export var buttonLg = "_a4-8";
export var filterGroupBox = "_a4-0";
export var icon = "_a4-3";
export var iconSecondary = "_a4-6";
export var iconWrapper = "_a4-4";
export var iconWrapperLg = "_a4-5";
export var truncatedLabel = "_a4-a";